import isoDark from "@/assets/xuma-isotipo.png"; // naranja + negro (fondos claros)
import isoLight from "@/assets/xuma-isotipo-light.png"; // naranja + blanco (fondos oscuros)

const SIZES = {
  sm: { img: "h-6", name: "text-base", tag: "text-[7px]" },
  md: { img: "h-8", name: "text-xl", tag: "text-[9px]" },
  lg: { img: "h-10", name: "text-2xl", tag: "text-[10px]" },
};

export const Logo = ({ variant = "dark", showTagline = true, size = "md", className = "" }) => {
  const onLight = variant === "dark"; // texto oscuro sobre fondo claro
  const iso = onLight ? isoDark : isoLight;
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img src={iso} alt="Xuma Social Business Card" className={`${s.img} w-auto shrink-0`} />
      <span className="leading-none">
        <span className={`block font-heading font-extrabold ${s.name} tracking-tight ${onLight ? "text-xuma-dark" : "text-white"}`}>
          Xuma
        </span>
        {showTagline && (
          <span className={`block ${s.tag} uppercase tracking-[0.2em] mt-1 ${onLight ? "text-xuma-muted" : "text-white/55"}`}>
            Social Business Card
          </span>
        )}
      </span>
    </span>
  );
};

export default Logo;
